module.exports = __webpack_public_path__ + "static/img/plan-task_03.35b76b49.png";